import { render, staticRenderFns } from "./TranslationManager.vue?vue&type=template&id=25eb2424&scoped=true&"
import script from "./TranslationManager.vue?vue&type=script&lang=js&"
export * from "./TranslationManager.vue?vue&type=script&lang=js&"
import style0 from "./TranslationManager.vue?vue&type=style&index=0&id=25eb2424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eb2424",
  null
  
)

export default component.exports